import { Dialog } from "primereact/dialog";
//import { GrDocumentPdf } from "react-icons/gr";
import { useGeneral } from "../contexts/GeneralInfoContext";
import { useAuth } from "../contexts/AuthInfoContext";
import { addHours, format } from "date-fns";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { formatCurrency } from "../utils/FormatCurrency";
import { Buffer } from "buffer";
import { useState } from "react";

function DialogOferta(props) {
  const { user } = useAuth();
  //const { infoFinanceira } = usePrivate()
  const { today } = useGeneral();
  const [mensagemProximoPasso, setMensagemProximoPasso] = useState(false);
  //const { boletoData } = useNegotiation()

  function relogio() {
    const hora = new Date().getHours();
    if (hora >= 5 && hora < 12) return "Bom dia";
    if (hora >= 12 && hora < 18) return "Boa tarde";
    return "Boa noite";
  }

  function baixarBoletos() {
    props.ofertaData.map((boleto, index) => {
      pdfBoletoDownload(boleto, index);
    });
    setMensagemProximoPasso(true);
  }

  function pdfBoletoDownload(e, index) {
    const data = e.boleto_base64;
    //console.log(data)
    const binary = Buffer.from(data.replace(/\s/g, ""), "base64").toString("binary");
    const len = binary.length;
    const buffer = new ArrayBuffer(len);
    //console.log(binary)
    let view = new Uint8Array(buffer);

    for (let i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([view], { type: "aplication/pdf" });
    const boleto = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = boleto;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.download = `Boleto_oferta_vencimento_:${format(
      addHours(new Date(e.cobranca_data_vencimento), 3),
      "dd/MM/yyyy"
    )}_Nº${Number(index + 1)}.pdf`;
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
    }, 100);
  }

  function selecionaPrejuizo() {
    const prejuizo = props.cobrancas.filter((cobranca) => cobranca.cobranca_descricao.includes("PREJUIZO"));
    const tudo_prejuizo = prejuizo.length === props.cobrancas.length;
    //console.log(tudo_prejuizo,prejuizo,props.cobrancas)
    return tudo_prejuizo ? "sua dívida" : "uma parte da sua dívida";
  }

  return (
    <Dialog
      visible
      header={props.ofertaData[0].cpc_descricao}
      onHide={() => props.close()}
      className="boletosDialog"
      style={{
        minHeigth: "30vw",
        minWidth: "20vw",
        textAlign: "center",
        borderRadius: "0.75rem",
      }}
    >
      {!mensagemProximoPasso ? (
        <div className="negotiationButton p-[1vw] text-center font-bold text-slate-700">
          <h5>
            {relogio()}, {user} temos uma oferta imperdível para você!!!
          </h5>
          <h6 className="mt-6">
            Você recebeu um desconto exclusivo para pagar {selecionaPrejuizo()}
            <br />
            e pode efetuar o download do seu boleto clicando no botão abaixo
            <br />
          </h6>
          {props.ofertaData.length > 1 && (
            <h6 className="mt-2">
              *Dívida parcelada devido ao valor.
              <br />
            </h6>
          )}
          {/* <div className="flex p-[1vh] justify-center">
                    <i className="text-6xl"><GrDocumentPdf></GrDocumentPdf></i>
                </div> */}
          <div className="mt-[4vh]">
            <DataTable
              value={props.ofertaData}
              className="boletosDialog overflow-auto " //h-[35vh]"
            >
              <Column
                body={(rowData) => formatCurrency(rowData.valor_original)}
                field="valor_original"
                header="Valor original"
              />
              <Column
                body={(rowData) => formatCurrency(rowData.valor_pagamento)}
                field="valor_pagamento"
                header="Valor com desconto"
              />
              <Column
                body={(rowData) => format(addHours(new Date(rowData.cobranca_data_vencimento), 3), "dd/MM/yyyy")}
                field="cobranca_data_vencimento"
                header="Vencimento boleto"
              />
            </DataTable>
            <button
              className="bg-[#001d74] w-full h-[6vh] text-slate-50 p-2
                    hover:bg-gradient-to-b hover:from-[#0000ff] hover:to-[#0040ff] 
                    hover:shadow-[1.5px_1.5px_5px_5px_#4300fa85] transition duration-300
                    disabled:hover:from-[#001d74]/0 disabled:hover:to-[#001d74]/0 
                    disabled:hover:shadow-none text-[2.5vh] mt-6
                    font-lato font-bold disabled:bg-[#001d74]/70 rounded-md "
              onClick={() => {
                baixarBoletos();
              }}
              type="button"
            >
              {props.ofertaData.length > 1 ? "Baixar Boletos" : "Baixar Boleto"}
            </button>
          </div>
        </div>
      ) : (
        <div className="negotiationButton p-[1vw] text-center font-bold text-slate-700">
          <h5 className="mb-6">Download efetuado com sucesso!</h5>
          <h6>
            Agora é só efetuar o pagamento do boleto gerado dentro do prazo de
            <br />
            vencimento em {format(addHours(new Date(props.ofertaData[0].cobranca_data_vencimento), 3), "dd/MM/yyyy")} e
            a sua cobrança será quitada.
            <br />
            Para fechar esta caixa e visualizar seus débitos
            <br />
            em atraso na plataforma clique no botão abaixo <br />
          </h6>
          <button
            className="bg-[#001d74] w-full h-[6vh] text-slate-50 p-2
                    hover:bg-gradient-to-b hover:from-[#0000ff] hover:to-[#0040ff] 
                    hover:shadow-[1.5px_1.5px_5px_5px_#4300fa85] transition duration-300
                    disabled:hover:from-[#001d74]/0 disabled:hover:to-[#001d74]/0 
                    disabled:hover:shadow-none text-[2.5vh] 
                    font-lato font-bold disabled:bg-[#001d74]/70 rounded-md mt-6"
            onClick={() => props.close()}
            type="button"
          >
            Continuar
          </button>
        </div>
      )}
    </Dialog>
  );
}

export default DialogOferta;
